import { type Operation } from 'fast-json-patch';
import { defaultSplitPanelItem } from './userDataSettings.reducer';
import type { UserSettingsState } from './userDataSettings.state';

export const getPathForUserDataSettingsTree = (diff: Operation[]): Operation[] => {
  const mappedDiff: Array<Operation> = [];

  diff.forEach(item => {
    const items: string[] = item.path.split('/').filter(item => item.length > 0); // split by "/" and remove empty

    const pathArray = ['settings', ...items];
    const path = pathArray.join('/');

    mappedDiff.push({
      ...item,
      path,
    });
  });

  return mappedDiff;
};

export const getSplitItemSettingsFromUserDataSettings = (
  userDataSettingsState: UserSettingsState | null,
  clientId: number | null,
  mapId: number | null,
) => {
  if (clientId === null || mapId === null) {
    return defaultSplitPanelItem;
  }

  const splitPanelState = userDataSettingsState?.[clientId]?.splitPanel;

  if (!splitPanelState) {
    return defaultSplitPanelItem;
  }

  return splitPanelState[mapId] ?? defaultSplitPanelItem;
};
